<div class="tt-stepper__mobile-progress">
    <div class="tt-stepper__mobile-progress-bar"></div>
    <div class="tt-stepper__mobile-progress-label">
        <span class="tt-stepper__step-indicator"></span>
        <span class="tt-stepper__step-label" [title]="steppers.get(+ttPageIndex)?.label">
            {{ steppers.get(+ttPageIndex)?.label + " (" + (+ttPageIndex + 1) + " / " + steppers.length + ")" }}
        </span>
    </div>
</div>
<div class="tt-stepper__steppers">
    <button
        class="tt-stepper__step tt-stepper__step--selected"
        *ngFor="let step of steppers; index as i"
        [ngClass]="{
            'tt-stepper__step--selected': ttPageIndex == i,
            'tt-stepper__step--complete': step.ttComplete,
            'tt-stepper__step--invalid': step.ttInvalid,
            'tt-stepper__step--visited': i < +ttPageIndex,
        }"
        (click)="onStepClicked(step, i)"
        [style.--tt-stepper__line-index]="i"
    >
        <span class="tt-stepper__step-indicator"></span>
        <span class="tt-stepper__step-label" [title]="step.label">{{ step.label }}</span>
    </button>
</div>
<div class="tt-stepper__content">
    <div class="tt-stepper__step-content flex-1" style="flex-shrink: 0; overflow: auto">
        <ng-container *ngIf="steppers.get(+ttPageIndex)?.label">
            <h3 class="tt-card__heading" style="font-size: var(--tt-font-size-xl); margin-top: 0.6rem">{{ steppers.get(+ttPageIndex)?.label }}</h3>
            <hr class="col-xs-12 sp-0 k-hr" style="margin-top: 0" />
        </ng-container>
        <ng-container *ngIf="steppers.get(+ttPageIndex)?.content">
            <ng-container *ngTemplateOutlet="steppers.get(+ttPageIndex)!.content!"></ng-container>
        </ng-container>
    </div>
    <!-- <ng-content select="tt-step"></ng-content> -->
    <div class="tt-stepper__buttons">
        <tt-button ttText="previous" ttType="secondary" (ttClick)="previous()" [ttDisabled]="ttPageIndex == 0"></tt-button>
        <tt-button ttText="next" ttType="primary" (ttClick)="next()" [ttDisabled]="ttPageIndex == steppers.length - 1"></tt-button>
    </div>
    <ng-content></ng-content>
</div>
